var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.857,
    height: 24.041,
    viewBox: "0 0 22.857 24.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1.428 2.02)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(1.289 2.499)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "_748ea525-a3a4-4055-8faa-404a13acbe37",
    "data-name": "748ea525-a3a4-4055-8faa-404a13acbe37",
    x1: 20,
    transform: "translate(-1.289 7.501)",
    fill: "none",
    stroke: "#f5b700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.857
  }), /*#__PURE__*/React.createElement("path", {
    id: "_0bcac280-6fc9-49ce-888e-4e486bab577c",
    "data-name": "0bcac280-6fc9-49ce-888e-4e486bab577c",
    d: "M17.143,27.143l-10-10,10-10",
    transform: "translate(-8.432 -9.642)",
    fill: "none",
    stroke: "#f5b700",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.857
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back-button.2caa59c05630f0625f4910029438a880.svg";
export { ForwardRef as ReactComponent };